export const css = {
    root: '_1Nv-LMMa',
    ' _key': 'apic-theme/apic/variants/aipc'
};
export default css;
